import React, { memo } from 'react'
import { graphql } from 'gatsby'

import IndexLayout from '~layouts/IndexLayout'
import ThreeColumnLayout from '~layouts/ThreeColumnLayout'

import Head from '~components/Head'
import References from '~components/References'

const ReferenceIndex = ({
  pageContext,
  data
}) => (
  <IndexLayout>
    <Head title={pageContext.title} />
    <ThreeColumnLayout alignment='wide'>
      <></>
      <References 
        title={pageContext.title}
        centeredTitle
        tags={data.tags.nodes} 
        resources={data.resources.nodes}
        showAll
      />
      <></>
    </ThreeColumnLayout>
  </IndexLayout>
)

export default memo(ReferenceIndex)

export const pageQuery = graphql`
  query {
    tags: allTag(sort: {fields: name}) {
      nodes {
        id
        name
        resources {
          id
          path
          title
        }
        endpoints {
          id
          urlPath
          title
          verb
        }
      }
    }
    resources: allResource(sort: {fields: key}, filter: {hide: {eq: false}}) {
      nodes {
        id
        path
        title
      }
    }
  }
`